var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Filter50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC80",
    d: "M29 23L19 23 7 9 41 9zM29 38L19 44 19 23 29 23zM41.5 9h-35C5.7 9 5 8.3 5 7.5v0C5 6.7 5.7 6 6.5 6h35C42.3 6 43 6.7 43 7.5v0C43 8.3 42.3 9 41.5 9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Filter50);
export default __webpack_public_path__ + "static/media/icons8-filter-50.cfcfc150d89571d49961f398f1ea6ea0.svg";
export { ForwardRef as ReactComponent };